var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'expand-icon-button',
    _vm.text && 'enable-expansion',
    _vm.disabled && 'disabled',
    _vm.active && 'opened',
    parseInt(_vm.sideLength, 10) <= 40 && 'smaller' ],on:{"click":_vm.handleButtonClick}},[_c('div',{staticClass:"icon",style:({ height: _vm.sideLength, width: _vm.sideLength })},[_c('ar-icon',{attrs:{"name":_vm.iconName,"width":_vm.iconSize.width,"height":_vm.iconSize.height}})],1),_vm._v(" "),(_vm.text)?_c('span',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }